
  import { defineComponent, onMounted, ref, computed } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import { VehicleObject } from '@/store/modules/assets/VehicleModule';
  import * as Yup from 'yup';

  export default defineComponent({
    name: 'vehicle-editing',
    components: {
      ErrorMessage,
      Field,
      Form,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const route = useRoute();
      const submitButton = ref<HTMLButtonElement | null>(null);
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };
      onMounted(async () => {
        setCurrentPageBreadcrumbs(translate('vehicleUpdating'), [
          translate('assets'),
        ]);

        await store.dispatch(Actions.GET_SHIPMENT_SIZES);
      });

      const { data } = await store.dispatch(
        Actions.GET_VEHICLE,
        route.params.id
      );

      const vehicle = ref<VehicleObject>(data.data);

      const titleAr = () => {
        return vehicle.value.name.find((i) => {
          if (i.languageCode === 'ar') {
            return i.title;
          }
        }).title;
      };

      const titleEn = () => {
        return vehicle.value.name.find((i) => {
          if (i.languageCode === 'en') {
            return i.title;
          }
        }).title;
      };

      const titleKu = () => {
        return vehicle.value.name.find((i) => {
          if (i.languageCode === 'ku') {
            return i.title;
          }
        }).title;
      };

      const goBack = () => {
        router.back();
      };
      const shipmentSchema = Yup.object().shape({
        titleAr: Yup.string()
          .required(() => translate('AR_TITLE_IS_REQUIRED_FIELD'))
          .label('Title Ar'),
        titleEn: Yup.string()
          .required(() => translate('EN_TITLE_IS_REQUIRED_FIELD'))
          .label('Title En'),
        titleKu: Yup.string()
          .required(() => translate('KU_TITLE_IS_REQUIRED_FIELD'))
          .label('Title Ku'),
      });
      const onSubmitCreate = async (values) => {
        values.title = [];
        values.title.push({ languageCode: 'en', title: values.titleEn });
        values.title.push({ languageCode: 'ar', title: values.titleAr });
        values.title.push({ languageCode: 'ku', title: values.titleKu });

        if (submitButton.value) {
          // eslint-disable-next-line
          submitButton.value!.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }
        if (values.isactive == true) {
          values.isactive = true;
        } else {
          values.isactive = false;
        }
        const payload = {
          isActive: values.isactive,
          title: values.title,
          size: values.size,
          modelYear: values.modelYear,
        };
        await store.dispatch(Actions.UPDATE_VEHICLE, {
          id: vehicle.value?.id,
          data: payload,
        });
        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];

        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
          //Deactivate indicator
          submitButton.value?.removeAttribute('data-kt-indicator');
          // eslint-disable-next-line
          submitButton.value!.disabled = false;
        } else {
          Swal.fire({
            text: translate('SUCCESSFULLY_CREATED_SHIPMENT_SIZE'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            router.push({ name: 'vehicles-listing' });
          });
        }
      };

      return {
        vehicle,
        sizes: computed(() => store.getters.shipmentSizeList),
        onSubmitCreate,
        submitButton,
        translate,
        shipmentSchema,
        goBack,
        titleAr,
        titleEn,
        titleKu,
        can,
      };
    },
  });
